import React, { ChangeEvent } from 'react'
import { DeviceEmail, FrecuencyEmail, TopicEmail } from '../../../../redux/slices/components/ScheduleEmails/scheduleEmailsSlice'
import ModalResumeScheduleEmail, { PreviewEmail } from './ModalResumeScheduleNotification/ModalResumeScheduleEmail'
import { ScheduleFrecuency } from '../../../ScheduleNotification/CreateScheduleNotification/CreateScheduleNotificationForm/CreateScheduleNotificationForm'

type ConModalResumeScheduleEmailProps = {
    frecuency: FrecuencyEmail
    subject: string
    topic: TopicEmail
    device: DeviceEmail
    schedule: ScheduleFrecuency
    bodyEmail: string
    onPreview: (type: PreviewEmail) => void
    onCloseModal: () => void
}

const ConModalResumeScheduleEmail = ({
    frecuency,
    subject,
    topic,
    device,
    schedule,
    bodyEmail,
    onPreview,
    onCloseModal,
}: ConModalResumeScheduleEmailProps) => {

    const handleClickOutsideModal = (e: any) => {
        const clickOutsideModal = document.getElementById("background-aux-modal")?.contains(e.target);
        if(!clickOutsideModal && e.target.id === "darkened-background-modal"){
            //dispatch( setShowJobModalRequestReducer(false) )
            onCloseModal()
        }
            
    }
  
    return (
        <>
            {
                <div onClick={(e) => { handleClickOutsideModal(e) }} id={"darkened-background-modal"} className="background-gray center">
                    <div id={"background-aux-modal"}>
                          <ModalResumeScheduleEmail
                                onCloseModal={onCloseModal}
                                frecuency={frecuency}
                                subject={subject}
                                topic={topic}
                                device={device}
                                schedule={schedule}
                                bodyEmail={bodyEmail}
                                onPreview={onPreview}
                          />
                    </div>
                </div>
            }
        </>
    )
}

export default React.memo( ConModalResumeScheduleEmail )